import { makeStyles } from '@material-ui/core';

export const searchHistoricoRemessaStyle = makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    padding: 16,
  },

  periodoVencimentoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '&>:first-child': {
      marginRight: 8,
    },
  },
  buttonSave: {
    background: '#43a047',
    border: '1px solid #43a047',
    color: '#fff',
    width: 90,
    height: 36,

    borderRadius: 5,
    textTransform: 'capitalize',
    transition: '0.4s',
    '&:hover': {
      color: '#43a047',
    },
    marginRight: '5px',
  },
}));
